import React, { useState, useEffect, useRef } from 'react';

const ConversationModal = ({ isOpen, onClose, onSelect, courses }) => {
    const [selectedCourse, setSelectedCourse] = useState('');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    
    // Reset selected course when modal opens
    useEffect(() => {
        if (isOpen) {
            setSelectedCourse('');
        }
    }, [isOpen]);
    
    // Handle clicks outside the dropdown
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        }
        
        // Add event listener when dropdown is open
        if (isDropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('touchstart', handleClickOutside);
        }
        
        // Clean up event listener
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [isDropdownOpen]);
    
    if (!isOpen) return null;

    const handleSelectChange = (e) => {
        e.preventDefault();
        setSelectedCourse(e.target.value);
    };

    const handleConfirm = () => {
        if (selectedCourse) {
            // Close the offcanvas by clicking the close button
            const closeButton = document.querySelector('.offcanvas-header .btn-close');
            if (closeButton) {
                closeButton.click();
            }
            
            onSelect(selectedCourse);
            onClose();
        } else {
            alert('Please select a course');
        }
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const selectOption = (course) => {
        setSelectedCourse(course);
        setIsDropdownOpen(false);
    };

    const sortedCourses = Array.isArray(courses) 
        ? [...courses].sort((a, b) => {
            const labelA = typeof a === 'string' ? a : (a?.label || '');
            const labelB = typeof b === 'string' ? b : (b?.label || '');
            return labelA.localeCompare(labelB);
          })
        : [];

    return (
        <div className="conversation-modal-overlay">
            <div className="conversation-modal-card">
                <h3>Start a New Conversation</h3>
                
                {/* Custom dropdown with outside click handling */}
                <div className="custom-select" ref={dropdownRef}>
                    <div 
                        className="custom-select-header"
                        onClick={toggleDropdown}
                        dir="auto"
                    >
                        {selectedCourse
                            ? (sortedCourses.find(c => (typeof c === 'string' ? c : c.name) === selectedCourse)?.label || selectedCourse)
                            : "Select Your Course..."}
                        <span className="custom-select-arrow">{isDropdownOpen ? '▲' : '▼'}</span>
                    </div>
                    
                    {isDropdownOpen && (
                        <div className="options-container" dir="auto">
                            {sortedCourses.map((course, index) => (
                                <div 
                                    key={typeof course === 'string' ? index : course.name} 
                                    className="select-option"
                                    onClick={() => selectOption(typeof course === 'string' ? course : course.name)}
                                >
                                    {typeof course === 'string' ? course : course.label}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                
                <div className="modal-buttons">
                    <button onClick={onClose} className="conversation-modal-button">
                        Cancel
                    </button>
                    <button onClick={handleConfirm} className="conversation-modal-button">
                        Create
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConversationModal;